/**
 * Sysadmin Catalog → Assignments — redirect stub.
 *
 * Background (issue #882 / SYSADMIN-PLATFORM-SPEC):
 *   The legacy `/sysadmin/catalog/assignments` URL has been moved out of the
 *   Catalog rail. Per the spec the canonical place to assign models (and
 *   other catalog entities) to tenants is the Asset Assignments tab on the
 *   tenant-detail page (`/sysadmin/tenants/:id/assignments`).
 *
 *   Before this stub, navigating to the legacy URL silently rendered the
 *   Catalog tab nav with an empty outlet body — looking to operators like
 *   the page "loaded" when in fact no content was being shown. That hides
 *   the founder-reported "no place to assign models to tenants" bug the
 *   spec was supposed to close.
 *
 * Behaviour: TanStack `redirect()` returns HTTP 307 / client-side
 * `Location` swap to the tenants list, where the operator picks the
 * target tenant and opens its Assignments tab.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/assignments')({
  beforeLoad: () => {
    throw redirect({
      to: '/sysadmin/tenants',
    });
  },
});
